<template>
    <div>
        <b-modal id="manual-variables" title="Dosya Gereksinimleri" no-close-on-esc no-close-on-backdrop>
            <employee-exit-files-variable v-model="file"/>
            <template #modal-footer><v-executer :action="sendGenerate" :loading="generating">Oluştur</v-executer></template>
        </b-modal>

        <b-modal id="upload-signed" title="İmzalı Evrak Yükle" no-close-on-esc no-close-on-backdrop>
            <div v-if="signedTarget">
                <p class="mb-1"><strong>{{ signedTarget.Name }}</strong> evrakının doldurulmuş ve imzalanmış halini yükleyiniz.</p>
                <v-file-uploader :accept="['pdf','png','jpg','jpeg']" :value="signedUpload" value-parameter="File"></v-file-uploader>
                <div v-if="signedTarget.SignedFilePath" class="text-muted mt-1">
                    Son yüklenen: {{ signedTarget.SignedFileUploadDateStr }}
                </div>
            </div>
            <template #modal-footer>
                <v-executer :action="sendSigned" :loading="uploadingSigned" :disabled="!signedUpload.File">Yükle</v-executer>
            </template>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    :buttons="buttons"
                    :settings="false">
                        <template #additional-actions>
                            <h3 class="mb-0">Çıkış Evrakları</h3>
                        </template>
        </v-table>
        <div class="text-right px-1 pb-1">
            <button class="btn btn-outline-secondary mr-1" v-on:click="$emit('prev-step')">Geri</button>
            <v-executer class="btn btn-danger btn-outline-danger" :loading="completing" text="Çıkışı Tamamla" :action="completeExit"></v-executer>
        </div>
    </div>
</template>

<script>
import EmployeeOperationsApi from '@/api/employee-operations'
import EmployeeExitFilesVariable from './EmployeeExitFilesVariable.vue'
import VFileUploader from '@/components/v-file-uploader/VFileUploader.vue'
import Additional from '@/utilities/additional'
import moment from 'moment'

export default {
    components:{
        EmployeeExitFilesVariable,
        VFileUploader
    },
    props:{
        id:[Number,String],
        taskId:[Number,String],
    },
    data(){
        return {
            fields:[
                {name:'Dosya Adı',key:'Name',thClass:'w-100'}
            ],
            buttons:[
                { text:"Oluştur",key:"generate",icon:"PlayIcon", variant:"primary", action:this.generate },
                { text:"İndir",key:"download",icon:"DownloadIcon", variant:"warning", action:this.download,condition:(item) => item.LastFilePath != null },
                { text:"Yazdır",key:"print",icon:"PrinterIcon", variant:"primary", action:this.print,condition:(item) => item.LastFilePath != null },
                { text:"Görüntüle",key:"view",icon:"EyeIcon", variant:"success", action:this.view,condition:(item) => item.LastFilePath != null },
                // İmzalı sürüm: yalnızca evrak oluşturulduktan sonra yüklenebilir.
                { text:"İmzalı Yükle",key:"uploadsigned",icon:"UploadIcon", variant:"danger", action:this.openSignedUpload,condition:(item) => item.LastFilePath != null },
                { text:"İmzalıyı İndir",key:"downloadsigned",icon:"CheckCircleIcon", variant:"success", action:this.downloadSigned,condition:(item) => item.SignedFilePath != null },
            ],
            file:null,
            generating:false,
            signedTarget:null,
            signedUpload:{ File:null },
            uploadingSigned:false,
            completing:false
        }
    },
    methods:{
        provider(){
            return EmployeeOperationsApi.ExitFiles(this.taskId)
        },
        // Çıkış artık bu adımda (evraklar) tamamlanır; arabuluculuk ayrı bir sayfaya taşındı.
        completeExit(){
            return new Promise((resolve)=>{
                this.$confirm('Çıkışı Tamamla','Çıkış işlemini tamamlamak istediğinize emin misiniz? Arabuluculuk süreci, çıkış tamamlandıktan sonra ayrı "Arabuluculuk" ekranından yürütülür.').then(c=>{
                    if(!c){ resolve(); return }
                    this.completing = true
                    EmployeeOperationsApi.CompleteExit(this.taskId).then(res=>{
                        this.completing = false
                        this.$result(res)
                        if(res.data.Success){
                            this.$emit('completed')
                        }
                        resolve()
                    }).catch(err=>{
                        this.completing = false
                        this.$result(null,err)
                        resolve()
                    })
                }).catch(()=>resolve())
            })
        },
        generate(item){
            this.file = structuredClone(item)
            if(Object.keys(item.ManualVariableValues || {}).length == 0){
                this.sendGenerate()
            }else{
                this.$showModal('manual-variables')
            }
        },
        sendGenerate(){
            this.$refs.table.rowLoading(true)
            this.generating = true
            const data = {
                SGKJobExitTaskId: this.taskId,
                Code: this.file.Code,
                Variables: (this.file.ManualVariableValues || []).map(d => {
                    if(d.DataType == 'date' && d.Value) {
                        return {
                            ...d,
                            Value:moment(d.Value,'YYYY-MM-DD').format('DD.MM.YYYY')
                        }
                    }else return d
                })
            }
            EmployeeOperationsApi.ExitGenerateFile(data).then(res => {
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('manual-variables')
                }
                this.$refs.table.rowLoading(false)
                this.generating = false
                this.$result(res)
            }).catch(err => {
                this.$refs.table.rowLoading(false)
                this.generating = false
                this.$result(null,err)
            })
        },
        download(item){
            Additional.DownloadTab(item.LastFilePath)
        },
        view(item){
            window.open(item.LastFilePath,'name','height=1100,width=794')
        },
        print(item){
            const w = window.open(item.LastFilePath,'name','height=1100,width=794')
            w.onload = () => { w.print() }
        },
        openSignedUpload(item){
            this.signedTarget = item
            this.signedUpload = { File:null }
            this.$showModal('upload-signed')
        },
        sendSigned(){
            if(!this.signedUpload.File || !this.signedTarget) return
            const formData = new FormData()
            formData.append('file', this.signedUpload.File)
            this.uploadingSigned = true
            return EmployeeOperationsApi.ExitUploadSignedFile(this.taskId, this.signedTarget.Id, formData).then(res => {
                this.uploadingSigned = false
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('upload-signed')
                    this.$refs.table.refresh()
                }
            }).catch(err => {
                this.uploadingSigned = false
                this.$result(null,err)
            })
        },
        downloadSigned(item){
            Additional.DownloadTab(item.SignedFilePath)
        },
    }
}
</script>